import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { MainComponent } from './main/main.component';
import { TopnavComponent } from './topnav/topnav.component';
import { TosComponent } from './tos/tos.component';
import { PpComponent } from './pp/pp.component';
import { LoginComponent } from './login/login.component';
import { SignupComponent } from './signup/signup.component';
import { ForBusinessComponent } from './for-business/for-business.component';


import { AngularFireModule } from "@angular/fire";
import { AngularFireAuthModule } from "@angular/fire/auth";
import { ReactiveFormsModule } from '@angular/forms';
import {AngularFireDatabaseModule} from '@angular/fire/database';
import {environment} from '../environments/environment';
import {AngularFireStorageModule} from '@angular/fire/storage';
import { CardCreatorComponent } from './card-creator/card-creator.component';

import "../assets/js/main.js";
import { HeaderTileComponent } from './header-tile/header-tile.component';
import { VideoTileComponent } from './video-tile/video-tile.component';
import { DashAdminComponent } from './dash-admin/dash-admin.component';
import { DashAgentComponent } from './dash-agent/dash-agent.component';
import { DashEmployeeComponent } from './dash-employee/dash-employee.component';
import { BasicThemeOneComponent } from './basic-theme-one/basic-theme-one.component';
import { CardDetailsComponent } from './card-details/card-details.component';
import { TodayCardsReportComponent } from './today-cards-report/today-cards-report.component';
import { TodayAgentsReportComponent } from './today-agents-report/today-agents-report.component';
import { TotalCardsReportComponent } from './total-cards-report/total-cards-report.component';
import { TotalAgentssReportComponent } from './total-agentss-report/total-agentss-report.component';
import { CardsBydaterangeReportComponent } from './cards-bydaterange-report/cards-bydaterange-report.component';
import { PaidCardsReportComponent } from './paid-cards-report/paid-cards-report.component';
import { CardsExpiryReportComponent } from './cards-expiry-report/cards-expiry-report.component';
import { UnpaidCardsReportComponent } from './unpaid-cards-report/unpaid-cards-report.component';
import { IndAgentCardsReportComponent } from './ind-agent-cards-report/ind-agent-cards-report.component';
import { BasicThemeTwoComponent } from './basic-theme-two/basic-theme-two.component';
import { BasicThemeThreeComponent } from './basic-theme-three/basic-theme-three.component';
import { BusinessThemeOneComponent } from './business-theme-one/business-theme-one.component';
import { BusinessThemeTwoComponent } from './business-theme-two/business-theme-two.component';
import { BusinessThemeThreeComponent } from './business-theme-three/business-theme-three.component';
import { ProfThemeOneComponent } from './prof-theme-one/prof-theme-one.component';
import { ProfThemeTwoComponent } from './prof-theme-two/prof-theme-two.component';
import { ProfThemeThreeComponent } from './prof-theme-three/prof-theme-three.component';

var config = {
  apiKey: "AIzaSyAIUPFwy39TV2OeohaNSUpiXzxGUz2NPaU",
  authDomain: "mydvc-1c65b.firebaseapp.com",
  projectId: "mydvc-1c65b",
  storageBucket: "mydvc-1c65b.appspot.com",
  messagingSenderId: "86939946500",
  appId: "1:86939946500:web:26c83a33a6bfddd7a22f51",
  measurementId: "G-ZL8RW7D0RQ"
};
@NgModule({
  declarations: [
    AppComponent,
    MainComponent,
    TopnavComponent,
    TosComponent,
    PpComponent,
    LoginComponent,
    SignupComponent,
    ForBusinessComponent,
    CardCreatorComponent,
    HeaderTileComponent,
    VideoTileComponent,
    DashAdminComponent,
    DashAgentComponent,
    DashEmployeeComponent,
    BasicThemeOneComponent,
    CardDetailsComponent,
    TodayCardsReportComponent,
    TodayAgentsReportComponent,
    TotalCardsReportComponent,
    TotalAgentssReportComponent,
    CardsBydaterangeReportComponent,
    PaidCardsReportComponent,
    CardsExpiryReportComponent,
    UnpaidCardsReportComponent,
    IndAgentCardsReportComponent,
    BasicThemeTwoComponent,
    BasicThemeThreeComponent,
    BusinessThemeOneComponent,
    BusinessThemeTwoComponent,
    BusinessThemeThreeComponent,
    ProfThemeOneComponent,
    ProfThemeTwoComponent,
    ProfThemeThreeComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    AngularFireAuthModule,
    ReactiveFormsModule,
    AngularFireStorageModule,
    AngularFireDatabaseModule,
    AngularFireModule.initializeApp(environment.firebaseConfig, "cloud"),
    FormsModule

  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
